import template from './case.pug';

/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('public.case', {
      abstract: true,
      url: '/case',
      template,
    });
}



// WEBPACK FOOTER //
// ./client/app/public/case/case.routes.js